import { Modal, Radio, Typography, Button } from 'antd'
import { Stack } from '@sureco/design-system'
import React from 'react'
const { Title, Text } = Typography

export default function LanguageModal({
  open,
  pendingFile,
  selectedLanguage,
  setSelectedLanguage,
  onCancel,
  onSave,
  isUploading,
}) {
  return (
    <Modal open={open} onCancel={onCancel} footer={null} centered>
      <Stack space={20} align="center">
        <Title level={3}>Select Language</Title>

        {pendingFile && (
          <div
            style={{
              padding: 12,
              background: '#F5FAFB',
              borderRadius: 8,
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Text>{pendingFile.name}</Text>
          </div>
        )}

        <Text>Please select the language this file is in:</Text>

        <Radio.Group
          value={selectedLanguage}
          onChange={(e) => setSelectedLanguage(e.target.value)}
        >
          <Stack space={8}>
            <Radio value="english">English</Radio>
            <Radio value="spanish">Spanish</Radio>
          </Stack>
        </Radio.Group>

        <Stack space={8} style={{ width: '100%' }}>
          <Button type="primary" onClick={onSave} loading={isUploading}>
            Save & Add
          </Button>
          <Button onClick={onCancel}>Cancel</Button>
        </Stack>
      </Stack>
    </Modal>
  )
}
